<template>
  <div :style="pageStyle">
    <div class="contentPage listPage">
      <div v-if="list && list.length"
        class="collectionItemList"
        :style="listStyle">
        <CollectionItem
          v-for="item in list"
          :key="item.collectionItemId"
          :locale="locale"
          :categoryId="categoryId"
          :lang="lang"
          :item="item"
          :data-item="item.collectionItemId"
          :collectionIcon="collectionIcon"
          :itemDisplay="itemDisplay"
          @deleteItem="deleteItem" />
      </div>
    </div>
  </div>
</template>

<script>
import CollectionItem from './MyCollectionItem'

export default {
  name: 'MyCollection',
  props: [
    'locale',
    'lang',
    'pageId',
    'categoryId'
  ],
  components: {
    CollectionItem
  },
  computed: {
    getMyCollectionSetting () {
      return this.$store.getters['collection/getMyCollectionSetting']
    },
    pageFrame () {
      const frame = this.$store.getters['collection/getPageFrame']
      return frame ? `${frame}px` : ''
    },
    pageStyle () {
      const frame = this.pageFrame
      return {
        padding: frame
      }
    },
    listStyle () {
      const setting = this.getMyCollectionSetting
      return {
        gridTemplateColumns: `repeat(${setting.listColumn}, 1fr)`
      }
    },
    itemDisplay () {
      const setting = this.getMyCollectionSetting
      return setting && setting.display
    },
    collectionIcon () {
      const myCollectionSetting = this.$store.getters['collection/getMyCollectionSetting']
      const scrapIcon = myCollectionSetting && {
        ...myCollectionSetting.scrapIcon,
        size: `${myCollectionSetting.scrapIcon.size}px`
      }
      return scrapIcon
    }
  },
  
  created () {
    this.init()
  },
  watch: {
    categoryId (categoryId) {
      this.getMyCollectionItems()
    }
  },
  beforeDestroy () {
    // 컴포넌트가 사라질 때 인터벌 제거
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
  mounted () {
    // 10초(10000ms)마다 호출
    this.intervalId = setInterval(() => {
      this.getMyCollectionItems()
    }, this.intervalDur)
  },
  data () {
    return {
      intervalDur: 10000,
      intervalId: null,
      list: []
    }
  },
  methods: {
    init () {
      const category = this.getMyCollectionSetting && this.getMyCollectionSetting.category
      const myCollectionCategoryId = getFirstCategoryId(category)
      function getFirstCategoryId (arr) {
        if (!arr || arr.length === 0) return null
        const first = arr[0]
        if (first.subCategory && first.subCategory && first.subCategory.length > 0) {
          return first.subCategory[0].categoryId
        }
        return first.categoryId
      }
      if (!this.categoryId) {
        if (myCollectionCategoryId) {
          this.$router.replace({ params: {
            ...this.$route.params,
            categoryId: myCollectionCategoryId
          } })
        }
      }
      this.getMyCollectionItems(myCollectionCategoryId)
    },
    async getMyCollectionItems (myCollectionCategoryId) {
      const collectionCategory = this.categoryId || myCollectionCategoryId
      const res = await this.$store.dispatch('collection/getMyCollectionItems', {pageId: this.pageId, collectionCategory: collectionCategory})
      const list = res && res.message
      if (list) {
        this.list = list
      }
    },
    async deleteItem (collectionItemId) {
      const data = {
        pageId: this.pageId,
        collectionCategory: this.categoryId,
        orderItemId: collectionItemId
      }
      this.$store.commit('loading', true)
      const res = await this.$store.dispatch('collection/removeMyCollectionItem', data)
      if (res && res.status === 200) {
        this.$store.commit('collection/setToastMessage', '내 콜렉션에서 삭제되었습니다.')
        this.getMyCollectionItems()
      } else {
        alert(res)
      }
      this.$store.commit('loading', false)
    }
  }
}
</script>